import React, { useState } from "react";
import { ChevronLeft, ChevronRight, X, ZoomIn, Play, Pause } from "lucide-react";

const PresentationSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(false);

  // Galerie photos complète et immersive - toutes les images + 4 nouvelles
  const galleryImages = [
    // Images principales d'intérieur
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/SALON1.jpg",
      alt: "Salon principal chaleureux avec décoration authentique",
      title: "Salon chaleureux",
      category: "interieur",
      featured: true
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/CUISINE 2 .jpg",
      alt: "Cuisine équipée moderne avec îlot central",
      title: "Cuisine équipée",
      category: "interieur",
      featured: true
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/SALLE A MANGER1.jpg",
      alt: "Salle à manger spacieuse pour 10 personnes",
      title: "Salle à manger",
      category: "interieur",
      featured: true
    },
    
    // Chambres
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/CHAMBRE 1.jpg",
      alt: "Chambre 1 avec literie confortable et décoration soignée",
      title: "Chambre 1",
      category: "chambres"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/CHAMBRE 1 - 1 .jpg",
      alt: "Vue alternative de la chambre 1 avec coin détente",
      title: "Chambre 1 - détail",
      category: "chambres"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/CHAMBRE 2 .jpg",
      alt: "Chambre 2 lumineuse avec vue sur le jardin",
      title: "Chambre 2",
      category: "chambres"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/CHAMBRE 2-1.jpg",
      alt: "Chambre 2 avec coin bureau et rangements",
      title: "Chambre 2 - espace",
      category: "chambres"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/CHAMBRE 3 .jpg",
      alt: "Chambre 3 avec décoration rustique et moderne",
      title: "Chambre 3",
      category: "chambres"
    },
    
    // Espaces extérieurs
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/TERRASSE.jpg",
      alt: "Terrasse extérieure avec salon de jardin et barbecue",
      title: "Terrasse",
      category: "exterieur",
      featured: true
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/direction jardin petanque animaux.jpg",
      alt: "Jardin spacieux avec terrain de pétanque et espace pour animaux",
      title: "Jardin & pétanque",
      category: "exterieur"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/terrain pétanque.jpg",
      alt: "Terrain de pétanque professionnel dans le jardin",
      title: "Terrain de pétanque",
      category: "exterieur"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/HAMAC.jpg",
      alt: "Hamac dans le jardin pour moments de détente",
      title: "Hamac relaxant",
      category: "exterieur"
    },
    
    // 4 nouvelles photos extérieures
    {
      src: "/CABANONEXTERIEUR.jpg",
      alt: "Cabanon extérieur pour rangement matériel de jardin",
      title: "Cabanon extérieur",
      category: "exterieur"
    },
    {
      src: "/LECHATDEHORS.jpg",
      alt: "Chat paisible sur le mur, ambiance authentique du gîte",
      title: "Chat paisible",
      category: "exterieur"
    },
    {
      src: "/CHAMPEXTERIEUR.jpg",
      alt: "Grand champ verdoyant aux alentours du gîte",
      title: "Champ verdoyant",
      category: "paysages",
      featured: true
    },
    {
      src: "/JARDINPANNEAU.jpg",
      alt: "Panneau bois artisanal indiquant Jardin et Bananeraie",
      title: "Panneau Jardin",
      category: "exterieur"
    },
    
    // Activités et alentours
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/table ping pong arbre.jpg",
      alt: "Table de ping-pong sous les arbres",
      title: "Table de ping-pong",
      category: "activites"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/transat terrain pétanque.jpg",
      alt: "Transats près du terrain de pétanque pour se détendre",
      title: "Espace détente",
      category: "exterieur"
    },

    // Nouvelles photos du jardin (2025)
    {
      src: "/images/jardin/rosiers-roses.jpg",
      alt: "Rosiers roses grimpants en fleurs dans le jardin",
      title: "Rosiers roses",
      category: "exterieur"
    },
    {
      src: "/images/jardin/rosiers-jaunes.jpg",
      alt: "Rosiers jaunes grimpants sur un poteau en bois",
      title: "Rosiers jaunes",
      category: "exterieur"
    },
    {
      src: "/images/jardin/hamac-poules.jpg",
      alt: "Hamac entre les arbres et poules dans le jardin arboré",
      title: "Hamac & poules",
      category: "exterieur"
    },
    {
      src: "/images/jardin/grande-terrasse-jour.jpg",
      alt: "Grande terrasse en bois avec salon de jardin",
      title: "Grande terrasse",
      category: "exterieur"
    },
    {
      src: "/images/jardin/terrasse-nuit-mobilier.jpg",
      alt: "Terrasse illuminée par des guirlandes lumineuses en soirée",
      title: "Ambiance nocturne",
      category: "exterieur"
    },
    
    // Paysages environnants
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/ETANG PARFAIT .jpg",
      alt: "Rivière pittoresque à 10 minutes à pied du gîte",
      title: "Rivière à proximité",  
      category: "paysages",
      featured: true
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/ETANG 10 mn a pied.jpg",
      alt: "Vue panoramique sur la rivière accessible à pied",
      title: "Promenade vers la rivière",
      category: "paysages"
    },
    {
      src: "/images/Photos-site-coeurd-de-normand-Gîte/PAYSAGE A 10MN A PIED.jpg",
      alt: "Paysages naturels de Suisse Normande à découvrir",
      title: "Paysages normands",
      category: "paysages"
    }
  ];

  // Images en vedette pour l'affichage principal
  const featuredImages = galleryImages.filter(img => img.featured);
  const interiorImages = galleryImages.filter(img => img.category === "interieur");
  const exteriorImages = galleryImages.filter(img => img.category === "exterieur");
  const bedroomImages = galleryImages.filter(img => img.category === "chambres");
  const landscapeImages = galleryImages.filter(img => img.category === "paysages");

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setIsAutoPlaying(false);
  };

  const nextImage = () => {
    const nextIndex = (currentImageIndex + 1) % galleryImages.length;
    setCurrentImageIndex(nextIndex);
    setSelectedImage(galleryImages[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = currentImageIndex === 0 ? galleryImages.length - 1 : currentImageIndex - 1;
    setCurrentImageIndex(prevIndex);
    setSelectedImage(galleryImages[prevIndex]);
  };

  // Auto-play functionality
  React.useEffect(() => {
    if (isAutoPlaying && selectedImage) {
      const interval = setInterval(nextImage, 3000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, selectedImage, currentImageIndex]);

  return (
    <section 
      id="presentation" 
      className="section-padding bg-white"
      aria-labelledby="presentation-title"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-12 md:mb-16">
          <h2 
            id="presentation-title"
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#1C3A27] mb-4 md:mb-6"
          >
            Présentation du lieu
          </h2>
        </div>

        {/* Texte de présentation mis à jour */}
        <div className="mb-12 md:mb-16">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-lg md:text-xl text-[#1C3A27]/80 leading-relaxed mb-8">
              Ancien hôtel-restaurant restauré avec soin pour accueillir jusqu'à <strong>10 personnes</strong> dans une 
              ambiance authentique, calme et chaleureuse. Situé à <strong>Clécy</strong>, à 5 minutes de l'Orne et des commerces.
            </p>
            
            {/* Informations clés */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-8">
              <div className="text-center p-4 bg-[#EDE6DB]/30 rounded-xl">
                <div className="font-serif text-2xl md:text-3xl font-bold text-[#1C3A27]">10</div>
                <div className="text-sm text-[#1C3A27]/70">Personnes</div>
              </div>
              <div className="text-center p-4 bg-[#EDE6DB]/30 rounded-xl">
                <div className="font-serif text-2xl md:text-3xl font-bold text-[#1C3A27]">3</div>
                <div className="text-sm text-[#1C3A27]/70">Chambres</div>  
              </div>
              <div className="text-center p-4 bg-[#EDE6DB]/30 rounded-xl">
                <div className="font-serif text-2xl md:text-3xl font-bold text-[#1C3A27]">3</div>
                <div className="text-sm text-[#1C3A27]/70">Salles d'eau</div>
              </div>
              <div className="text-center p-4 bg-[#EDE6DB]/30 rounded-xl">
                <div className="font-serif text-2xl md:text-3xl font-bold text-[#1C3A27]">130</div>
                <div className="text-sm text-[#1C3A27]/70">m²</div>
              </div>
            </div>
          </div>
        </div>

        {/* GALERIE IMMERSIVE - Expérience grandiose */}
        <div className="mb-12">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#1C3A27] mb-8 text-center">
            Galerie immersive - Découvrez nos espaces
          </h3>
          
          {/* Images en vedette - Format héro */}
          <div className="mb-12">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
              {/* Image principale large */}
              <div 
                className="lg:col-span-2 group relative aspect-[16/10] overflow-hidden rounded-2xl shadow-2xl cursor-pointer transform transition-all duration-500 hover:scale-[1.02] hover:shadow-3xl"
                onClick={() => openLightbox(featuredImages[0], galleryImages.indexOf(featuredImages[0]))}
              >
                <img
                  src={featuredImages[0]?.src}
                  alt={featuredImages[0]?.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-6 left-6 right-6">
                    <h4 className="text-white font-serif text-xl md:text-2xl font-bold mb-2">
                      {featuredImages[0]?.title}
                    </h4>
                    <p className="text-white/90 text-sm">
                      {featuredImages[0]?.alt}
                    </p>
                  </div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <ZoomIn size={24} className="text-white" />
                  </div>
                </div>
              </div>

              {/* Images secondaires */}
              <div className="space-y-4 md:space-y-6">
                {featuredImages.slice(1, 3).map((image, index) => (
                  <div
                    key={index}
                    className="group relative aspect-[4/3] overflow-hidden rounded-xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
                    onClick={() => openLightbox(image, galleryImages.indexOf(image))}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                      <ZoomIn 
                        size={20} 
                        className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" 
                      />
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                      <p className="text-white text-sm font-medium">{image.title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Galerie par catégories - Format mosaïque fluide */}
          <div className="space-y-12">
            {/* Intérieurs */}
            <div>
              <h4 className="font-serif text-xl font-bold text-[#1C3A27] mb-6">Espaces de vie</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
                {interiorImages.map((image, index) => (
                  <div
                    key={index}
                    className="group relative aspect-square overflow-hidden rounded-lg shadow-md cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
                    onClick={() => openLightbox(image, galleryImages.indexOf(image))}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                      <ZoomIn 
                        size={18} 
                        className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" 
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Chambres */}
            <div>
              <h4 className="font-serif text-xl font-bold text-[#1C3A27] mb-6">Chambres</h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                {bedroomImages.map((image, index) => (
                  <div
                    key={index}
                    className="group relative aspect-[4/3] overflow-hidden rounded-lg shadow-md cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
                    onClick={() => openLightbox(image, galleryImages.indexOf(image))}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                      <ZoomIn 
                        size={18} 
                        className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" 
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Extérieurs & Nouvelles photos */}
            <div>
              <h4 className="font-serif text-xl font-bold text-[#1C3A27] mb-6">Jardin & Extérieurs</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
                {exteriorImages.map((image, index) => (
                  <div
                    key={index}
                    className="group relative aspect-square overflow-hidden rounded-lg shadow-md cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
                    onClick={() => openLightbox(image, galleryImages.indexOf(image))}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                      <ZoomIn 
                        size={16} 
                        className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" 
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Paysages */}
            <div>
              <h4 className="font-serif text-xl font-bold text-[#1C3A27] mb-6">Paysages environnants</h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                {landscapeImages.map((image, index) => (
                  <div
                    key={index}
                    className="group relative aspect-[3/2] overflow-hidden rounded-xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
                    onClick={() => openLightbox(image, galleryImages.indexOf(image))}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                      <ZoomIn 
                        size={20} 
                        className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" 
                      />
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                      <p className="text-white text-sm font-medium">{image.title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Lightbox Modal Amélioré */}
        {selectedImage && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <div className="relative max-w-6xl max-h-full">
              {/* Controls top bar */}
              <div className="absolute top-4 left-4 right-4 z-10 flex justify-between items-center">
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => setIsAutoPlaying(!isAutoPlaying)}
                    className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors"
                    aria-label={isAutoPlaying ? "Pause slideshow" : "Play slideshow"}
                  >
                    {isAutoPlaying ? <Pause size={20} /> : <Play size={20} />}
                  </button>
                  <div className="text-white/80 text-sm bg-black/30 backdrop-blur-sm px-3 py-1 rounded-full">
                    {currentImageIndex + 1} / {galleryImages.length}
                  </div>
                </div>
                
                <button
                  onClick={closeLightbox}
                  className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors"
                  aria-label="Fermer la galerie"
                >
                  <X size={20} />
                </button>
              </div>

              {/* Navigation buttons */}
              <button
                onClick={prevImage}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors"
                aria-label="Image précédente"
              >
                <ChevronLeft size={24} />
              </button>

              <button
                onClick={nextImage}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors"
                aria-label="Image suivante"
              >
                <ChevronRight size={24} />
              </button>

              {/* Image principale */}
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="max-w-full max-h-full object-contain rounded-lg"
              />

              {/* Informations image */}
              <div className="absolute bottom-4 left-4 right-4 bg-black/50 backdrop-blur-sm rounded-lg p-6">
                <h4 className="text-white font-serif text-xl font-bold mb-2">{selectedImage.title}</h4>
                <p className="text-white/90 text-sm leading-relaxed">{selectedImage.alt}</p>
                {selectedImage.category && (
                  <span className="inline-block mt-2 px-3 py-1 bg-white/20 text-white text-xs rounded-full">
                    {selectedImage.category}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PresentationSection;